module.exports = __webpack_public_path__ + "assets/img/样机-2-min.02320c1c.png";